import { Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

export default function RootModalWithAction({
  children,
  className = "max-w-md p-10",
  open,
  handleClose,
  title,
  titleClassName = "text-body-xl font-semibold",
  subTitle,
  subTitleClassName = "text-body-md",
  headClassName = "",
  showAdd = false,
  addAction = () => {},
  addText = "",
  hideBorder = false,
  hideCloseIcon = false,
  headerLayout = "default", // "default" | "compact"
  renderCompactActions = null,
  closeOnOutsideClick = true, // New prop to control closing on outside click
}) {
  const closeButton = !hideCloseIcon && (
    <button
      className="p-[6px] transition-all rounded-full max-w-8 cursor-pointer bg-blue-200 hover:bg-REELTeal hover:text-white text-teal-300"
      onClick={handleClose}
    >
      <span className="sr-only">Close panel</span>
      <XMarkIcon className="w-5 h-5 m-auto" strokeWidth="2" aria-hidden="true" />
    </button>
  );

  const renderDefaultAddButton = (classNameOverride = "") =>
    showAdd && (
      <button
        className={`disabled:opacity-40 h-5 min-w-[220px] rounded-full bg-REELTeal border-REELTeal hover:bg-teal-200 text-white inline-flex border transition-all duration-300 items-center font-semibold justify-center p-5 ${classNameOverride}`}
        onClick={() => addAction()}
      >
        {addText}
      </button>
    );

  const compactActionsNode = renderCompactActions
    ? renderCompactActions({ CloseButton: closeButton })
    : (
      <div className="flex items-center gap-6">
        {renderDefaultAddButton()}
        {closeButton}
      </div>
    );

  return (
    <Transition
      enter="transition duration-300 ease-out"
      enterFrom="transform scale-100 opacity-0"
      enterTo="transform scale-100 opacity-100"
      leave="transition duration-300 ease-out"
      leaveFrom="transform scale-300 opacity-100"
      leaveTo="transform scale-100 opacity-0"
      className={"fixed  top-0 left-0 w-full h-screen z-20 "}
      show={open}
    >
      <div
        className="fixed inset-0 bg-black/10 z-[1] shr "
        onClick={closeOnOutsideClick ? handleClose : undefined}
        aria-hidden="true"
      />
      <Transition.Child
        enter="transition duration-300 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-300 ease-out"
        leaveFrom="transform scale-300 opacity-100"
        leaveTo="transform scale-95 opacity-0"
        className={`bg-white z-[3] flex flex-col gap-1 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-[10px] shadow-xl max-h-[90vh] overflow-hidden ${className}`}
      >
        <div className={headerLayout === "compact" ? "pt-2" : hideCloseIcon ? "pt-0" : "pt-4"}>
          {headerLayout === "compact" ? (
            <div className={`flex w-full flex-row justify-between items-center rounded-b-none rounded-[4px] ${headClassName}`}>
              <h3 className={`text-[24px] text-start text-gray-800 font-semibold ${titleClassName}`}>
                {title}
              </h3>
              {compactActionsNode}
            </div>
          ) : (
            <>
              {!hideCloseIcon && (
                <button
                  className="p-[6px] absolute transition-all rounded-full max-w-8 cursor-pointer right-6 top-4 bg-blue-200 hover:bg-REELTeal hover:text-white text-teal-300"
                  onClick={handleClose}
                >
                  <span className="sr-only">Close panel</span>
                  <XMarkIcon className="w-5 h-5 m-auto" strokeWidth="2" aria-hidden="true" />
                </button>
              )}
              <div className={`flex w-full flex-row justify-between items-center rounded-b-none rounded-[4px] ${headClassName}`}>
                <div className="flex flex-col items-start gap-3 flex-1">
                  <div className={hideCloseIcon ? "h-0" : "h-8"}>
                    {subTitle !== "" && (
                      <div className={`text-start text-gray-900 m-0 ${subTitleClassName}`}>
                        {subTitle}
                      </div>
                    )}
                  </div>
                  <h3 className={`text-[24px] text-start text-gray-800 font-semibold ${titleClassName}`}>
                    {title}
                  </h3>
                </div>
                <div className={`flex gap-2 ${hideCloseIcon ? "pt-2" : "pt-8"}`}>
                  {renderDefaultAddButton("!min-w-[220px]")}
                </div>
              </div>
            </>
          )}
          {!hideBorder && <p className="border-t border-gray-200 mx-8" />}
        </div>
        <div className="flex-1 min-h-0 overflow-hidden flex flex-col">
          {children}
        </div>
      </Transition.Child>
    </Transition>
  );
}
